export default __webpack_public_path__ + "locales/tr/Common.json?hash=39d8aec176b0b2611aacf73058b209a3";